<template>
  <div id="main">

    <split-pane :min-percent='10' :default-percent='20' split="vertical">
      <template slot="paneL">
        <div id="omTreeDivs">
          <OrgTree :parentMsg="parentMsg" v-on:treeInfo="getTreeInfo"></OrgTree>
        </div>
      </template>
      <template slot="paneR">
        <div id="listTables">
          <div style="display: flex;align-items: center;justify-content: space-between;">
            <div class="rightTopButton">
              <el-button size="small" type="primary" v-if="!pid" icon="el-icon-refresh" @click="showChangeOrg"  plain>移动组织</el-button>
              <el-button size="small" type="primary" icon="el-icon-plus" @click="addForm"  plain>新增组织</el-button>
            </div>
            <div style="margin-right: 10px;display: flex;font-size: 12px;align-items: center;">
              <div>组织名称：</div>
              <el-input style="width: 180px" placeholder="请输入组织名称" clearable size="small" v-model="filterForm.name"></el-input>
<!--              <div style="margin-left: 10px;">信用代码：</div>-->
<!--              <el-input style="width: 180px;" placeholder="请输入信用代码" clearable size="small" v-model="filterForm.instituCreditCode"></el-input>-->
              <el-button size="small" type="primary" style="margin-left: 10px;" @click="queryData">搜索</el-button>
<!--              <el-button size="small" @click="querySet">重置</el-button>-->
            </div>
          </div>
          <div class="rightContent">
            <div class="table">
              <el-table
                      :data="tableData"
                      border
                      stripe
                      size="small"
                      :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
                      style="width: 100%"
                      @selection-change="handleSelectionChange"
                      height="100%">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column
                        type="index"
                        align="center"
                        width="50"
                        label="序号">
                  <template slot-scope="scope">
                    <span>{{getSn(scope)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                        prop="name"
                        align="left"
                        header-align="center"
                        min-width="200"
                        show-overflow-tooltip
                        label="组织名称">
                </el-table-column>
<!--                <el-table-column-->
<!--                        prop="shortName"-->
<!--                        align="left"-->
<!--                        header-align="center"-->
<!--                        width="150"-->
<!--                        show-overflow-tooltip-->
<!--                        label="简称">-->
<!--                </el-table-column>-->
                <el-table-column
                  width="200"
                  prop="instituCreditCode"
                  align="center"
                  header-align="center"
                  show-overflow-tooltip
                  label="信用代码">
                </el-table-column>
                <el-table-column
                        prop="commPerson"
                        align="center"
                        width="100"
                        label="法定代表人">
                </el-table-column>
                <el-table-column
                        prop="commPhone"
                        align="center"
                        width="120"
                        label="法人联系电话">
                </el-table-column>
                <el-table-column
                        prop="officeAddress"
                        align="left"
                        min-width="200"
                        header-align="center"
                        show-overflow-tooltip
                        label="办公地址">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        :width="curOrgType&&curOrgType.code == 'bx'?'180':'140'">
                  <template slot-scope="scope">
                    <el-tooltip content="设置管理员" placement="top">
                      <el-button size="mini" icon="el-icon-setting" @click="showSettingAdmin(scope.row)" circle></el-button>
                    </el-tooltip>
                    <el-tooltip v-if="curOrgType&&curOrgType.code == 'bx'" content="绑定企业" placement="top">
                      <el-button size="mini" type="primary" icon="el-icon-user" @click="disPerson(scope.$index, scope.row)" circle plain></el-button>
                    </el-tooltip>
                    <el-tooltip content="编辑" placement="top">
                      <el-button size="mini" type="primary" icon="el-icon-edit" @click="editForm(scope.row)" circle plain></el-button>
                    </el-tooltip>
                    <el-tooltip content="删除" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" @click="showDelAlert(scope.row)" circle plain></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination">
              <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-sizes="[10, 30, 50, 100]"
                      :page-size="rows"
                      background
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="totle">
              </el-pagination>
            </div>
          </div>
        </div>

        <div class="bumDialogDiv">
          <el-dialog title="组织信息" width="60%" :close-on-click-modal="false" :visible.sync="dialogAddFormVisible">
            <el-form :model="form" label-width="80px" :rules="rules" ref="form">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="组织名称" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="form.name" placeholder="请输入组织名称"></el-input>
                  </el-form-item>
                </el-col>
<!--                <el-col :span="12">-->
<!--                  <el-form-item label="简称" :label-width="formLabelWidth" >-->
<!--                    <el-input v-model.number="form.shortName" placeholder="请输入简称"></el-input>-->
<!--                  </el-form-item>-->

<!--                </el-col>-->
                <el-col :span="12">
                  <el-form-item label="机构信用代码" :label-width="formLabelWidth" prop="instituCreditCode">
                    <el-input style="width: 100%;" v-model="form.instituCreditCode" placeholder="请输入机构信用代码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="行政组织类型" :label-width="formLabelWidth" prop="orgType">
                    <el-select v-model="form.orgType" :disabled="!!$route.query.pid" @change="changeOrgType" placeholder="请选择行政组织类型" style="width: 100%;">
                      <el-option v-for="item in aoType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>

                </el-col>
                <el-col v-if="curOrgType&&curOrgType.code == 'bx'" :span="12">
                  <el-form-item label="保险机构编码" :label-width="formLabelWidth" prop="issueGeneralCompanyId">
                    <el-input style="width: 100%;" v-model="form.issueGeneralCompanyId" placeholder="请输入保险机构编码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col v-if="curOrgType&&curOrgType.code == 'qy'" :span="12">
<!--                  <el-form-item label="所属保险公司" :label-width="formLabelWidth" prop="xxxxxx">-->
<!--                    <Treeselect placeholder="请选择所属保险公司" style="width:100%;" :normalizer="normalizer" v-model="form.xxxxxx" :options="bxTreeData" />-->
<!--                  </el-form-item>-->
                </el-col>
<!--                <el-col :span="12">-->
<!--                  <el-form-item label="排序号" :label-width="formLabelWidth" prop="orderNo">-->
<!--                    <el-input v-model.number="form.orderNo" placeholder="请输入排序号"></el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="12">
                  <el-form-item label="法定代表人" :label-width="formLabelWidth" prop="commPerson">
                    <el-input v-model="form.commPerson" placeholder="请输入法定代表人"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="法人联系电话" :label-width="formLabelWidth" prop="orderNo">
                    <el-input v-model.number="form.commPhone" @input="handlePhoneInput($event,form,'commPhone')" placeholder="请输入法人联系电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="安全责任人" :label-width="formLabelWidth" prop="safetyPerson">
                    <el-input v-model="form.safetyPerson" placeholder="请输入安全责任人"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="责任人电话" :label-width="formLabelWidth" prop="safetyPersonPhone">
                    <el-input v-model.number="form.safetyPersonPhone" @input="handlePhoneInput($event,form,'safetyPersonPhone')" placeholder="请输入责任人电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所在城市" :label-width="formLabelWidth" prop="provincecode">
                    <el-cascader
                      placeholder="请选择所在城市"
                      v-model="form.cityCode"
                      style="width: 100%;"
                      :options="areaData"
                      filterable
                      ref="cascaderRef"
                      :props="{
                        value:'CODE',
                        label:'NAME'
                      }"
                      clearable
                      @change="handleChangeAddress"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="详细地址" :label-width="formLabelWidth" prop="enterprise_address">
                    <el-input v-model="form.officeAddress" placeholder="请输入详细地址"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="经营范围" :label-width="formLabelWidth" prop="businessScope">
                    <el-input v-model="form.businessScope" placeholder="请输入经营范围"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="职工人数" :label-width="formLabelWidth" prop="insuredNum">
                    <el-input v-model="form.insuredNum" placeholder="请输入职工人数"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="经济行业分类" :label-width="formLabelWidth" prop="economicIndustryClass">
<!--                    <el-input v-model="form.economicIndustryClass" placeholder="请输入经济行业分类"></el-input>-->
                    <el-cascader
                      placeholder="请选择经济行业分类"
                      v-model="form.economicIndustryClass"
                      style="width: 100%;"
                      :options="economicIndustryClassData"
                      filterable
                      ref="cascaderRefJj"
                      :props="{
                        value:'code',
                        label:'name',
                        checkStrictly: true
                      }"
                      @change="handleChangeAddressJj"
                      clearable></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="管理分类" :label-width="formLabelWidth" prop="managementClassCode">
<!--                    <el-input v-model="form.managementClassCode" placeholder="请输入管理分类"></el-input>-->
                    <el-cascader
                      placeholder="请选择管理分类"
                      v-model="form.managementClassCode"
                      style="width: 100%;"
                      :options="managementClassCodeData"
                      filterable
                      ref="cascaderRefGl"
                      :props="{
                        value:'CODE',
                        label:'NAME',
                        checkStrictly: true
                      }"
                      @change="handleChangeAddressGl"
                      clearable></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-if="false" style="border: 1px solid #ddd;padding: 0 10px;border-radius: 4px;height: calc(100% - 101px);">
                <div style="height: 40px;display: flex;align-items: center;justify-content: space-between;width: calc(100% - 0px);">
                  <div style="width: 68px;text-align: right;padding-right: 12px;font-size: 16px;font-weight: 800;">保险信息</div>
                  <el-button type="primary" :disabled="(form.orgInsurances&&form.orgInsurances.length>=7)" size="mini" @click="addItem">添加</el-button>
                </div>
                <div style="width: 100%;height: calc(100% - 40px);overflow-y: auto;">
                  <el-row v-for="(item,i) in form.orgInsurances" :key="i" style="margin-top: 8px;">
                    <el-col :span="4">
                      <el-form-item label="保险种类" prop="name">
                        <el-select style="width: 100%;" v-model="item.insuranceType" placeholder="请选择保险种类">
                          <el-option
                            v-for="item in insuranceTypeData"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item label="是否购买" prop="name">
                        <el-radio-group v-model="item.purchased">
                          <el-radio :label="1">是</el-radio>
                          <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="保险起期" prop="begintime">
                        <el-date-picker
                          v-model="item.startDate"
                          style="width: 100%;"
                          @change="$forceUpdate()"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          clearable
                          placeholder="选择保险起期">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="保险止期" prop="begintime">
                        <el-date-picker
                          v-model="item.endDate"
                          style="width: 100%;"
                          @change="$forceUpdate()"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          clearable
                          placeholder="选择保险止期">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="上传保单" prop="namesss">
                        <el-upload
                          class="upload-demo"
                          ref="uploadHt"
                          accept=".doc,.docx,.pdf"
                          action="#"
                          :multiple="false"
                          :file-list="item.fileListHt"
                          :on-remove="(file,fileLIst)=>handleRemoveHt(file,fileLIst,item)"
                          :on-change="(file,fileLIst)=>handleChangeHt(file,fileLIst,item)"
                          :on-preview="handlePreview"
                          :auto-upload="false">
                          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2">
                      <el-button type="danger" size="mini" style="float: right;" :disabled="form.orgInsurances.length==1" @click="deleteRow(i)">删除</el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="saveForm('form')" size="medium">确 定</el-button>
              <el-button @click="dialogAddFormVisible = false" size="medium">取 消</el-button>
            </div>
          </el-dialog>
          <el-dialog title="组织信息" width="60%" :close-on-click-modal="false" :visible.sync="dialogEditFormVisible">
            <el-form :model="form" label-width="80px" :rules="rules" ref="form">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="组织名称" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="form.name" placeholder="请输入组织名称"></el-input>
                  </el-form-item>
                </el-col>
<!--                <el-col :span="12">-->
<!--                  <el-form-item label="简称" :label-width="formLabelWidth" >-->
<!--                    <el-input v-model.number="form.shortName" placeholder="请输入简称"></el-input>-->
<!--                  </el-form-item>-->

<!--                </el-col>-->
                <el-col :span="12">
                  <el-form-item label="机构信用代码" :label-width="formLabelWidth" prop="instituCreditCode">
                    <el-input style="width: 100%;" v-model="form.instituCreditCode" placeholder="请输入机构信用代码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="行政组织类型" :label-width="formLabelWidth" prop="orgType">
                    <el-select v-model="form.orgType" :disabled="!!$route.query.pid" @change="changeOrgType" placeholder="请选择行政组织类型" style="width: 100%;">
                      <el-option v-for="item in aoType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>

                </el-col>
                <el-col v-if="curOrgType&&curOrgType.code == 'bx'" :span="12">
                  <el-form-item label="保险机构编码" :label-width="formLabelWidth" prop="issueGeneralCompanyId">
                    <el-input style="width: 100%;" v-model="form.issueGeneralCompanyId" placeholder="请输入保险机构编码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col v-if="curOrgType&&curOrgType.code == 'qy'" :span="12">
<!--                  <el-form-item label="所属保险公司" :label-width="formLabelWidth" prop="xxxxxx">-->
<!--                    <Treeselect placeholder="请选择所属保险公司" style="width:100%;" :normalizer="normalizer" v-model="form.xxxxxx" :options="bxTreeData" />-->
<!--                  </el-form-item>-->
                </el-col>
<!--                <el-col :span="12">-->
<!--                  <el-form-item label="排序号" :label-width="formLabelWidth" prop="orderNo">-->
<!--                    <el-input v-model.number="form.orderNo" placeholder="请输入排序号"></el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="12">
                  <el-form-item label="法定代表人" :label-width="formLabelWidth" prop="commPerson">
                    <el-input v-model="form.commPerson" placeholder="请输入法定代表人"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="法人联系电话" :label-width="formLabelWidth" prop="orderNo">
                    <el-input v-model.number="form.commPhone" @input="handlePhoneInput($event,form,'commPhone')" placeholder="请输入法人联系电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="安全责任人" :label-width="formLabelWidth" prop="safetyPerson">
                    <el-input v-model="form.safetyPerson" placeholder="请输入安全责任人"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="责任人电话" :label-width="formLabelWidth" prop="safetyPersonPhone">
                    <el-input v-model.number="form.safetyPersonPhone" @input="handlePhoneInput($event,form,'safetyPersonPhone')" placeholder="请输入责任人电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所在城市" :label-width="formLabelWidth" prop="provincecode">
                    <el-cascader
                      placeholder="请选择所在城市"
                      v-model="form.cityCode"
                      style="width: 100%;"
                      :options="areaData"
                      filterable
                      ref="cascaderRef"
                      :props="{
                        value:'CODE',
                        label:'NAME'
                      }"
                      clearable
                      @change="handleChangeAddress"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="详细地址" :label-width="formLabelWidth" prop="enterprise_address">
                    <el-input v-model="form.officeAddress" placeholder="请输入详细地址"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="经营范围" :label-width="formLabelWidth" prop="businessScope">
                    <el-input v-model="form.businessScope" placeholder="请输入经营范围"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="职工人数" :label-width="formLabelWidth" prop="insuredNum">
                    <el-input v-model="form.insuredNum" placeholder="请输入职工人数"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="经济行业分类" :label-width="formLabelWidth" prop="economicIndustryClass">
                    <!--                    <el-input v-model="form.economicIndustryClass" placeholder="请输入经济行业分类"></el-input>-->
                    <el-cascader
                      placeholder="请选择经济行业分类"
                      v-model="form.economicIndustryClass"
                      style="width: 100%;"
                      :options="economicIndustryClassData"
                      filterable
                      ref="cascaderRefJj"
                      :props="{
                        value:'code',
                        label:'name',
                        checkStrictly: true
                      }"
                      @change="handleChangeAddressJj"
                      clearable></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="管理分类" :label-width="formLabelWidth" prop="managementClassCode">
                    <!--                    <el-input v-model="form.managementClassCode" placeholder="请输入管理分类"></el-input>-->
                    <el-cascader
                      placeholder="请选择管理分类"
                      v-model="form.managementClassCode"
                      style="width: 100%;"
                      :options="managementClassCodeData"
                      filterable
                      ref="cascaderRefGl"
                      :props="{
                        value:'CODE',
                        label:'NAME',
                        checkStrictly: true
                      }"
                      @change="handleChangeAddressGl"
                      clearable></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-if="false" style="border: 1px solid #ddd;padding: 0 10px;border-radius: 4px;height: calc(100% - 101px);">
                <div style="height: 40px;display: flex;align-items: center;justify-content: space-between;width: calc(100% - 0px);">
                  <div style="width: 68px;text-align: right;padding-right: 12px;font-size: 16px;font-weight: 800;">保险信息</div>
                  <el-button type="primary" :disabled="(form.orgInsurances&&form.orgInsurances.length>=7)" size="mini" @click="addItem">添加</el-button>
                </div>
                <div style="width: 100%;height: calc(100% - 40px);overflow-y: auto;">
                  <el-row v-for="(item,i) in form.orgInsurances" :key="i" style="margin-top: 8px;">
                    <el-col :span="4">
                      <el-form-item label="保险种类" prop="name">
                        <el-select style="width: 100%;" v-model="item.insuranceType" placeholder="请选择保险种类">
                          <el-option
                            v-for="item in insuranceTypeData"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item label="是否购买" prop="name">
                        <el-radio-group v-model="item.purchased">
                          <el-radio :label="1">是</el-radio>
                          <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="保险起期" prop="begintime">
                        <el-date-picker
                          v-model="item.startDate"
                          style="width: 100%;"
                          @change="$forceUpdate()"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          clearable
                          placeholder="选择保险起期">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="保险止期" prop="begintime">
                        <el-date-picker
                          v-model="item.endDate"
                          style="width: 100%;"
                          @change="$forceUpdate()"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          clearable
                          placeholder="选择保险止期">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="上传保单" prop="namesss">
                        <el-upload
                          class="upload-demo"
                          ref="uploadHt"
                          accept=".doc,.docx,.pdf"
                          action="#"
                          :multiple="false"
                          :file-list="item.fileListHt"
                          :on-remove="(file,fileLIst)=>handleRemoveHt(file,fileLIst,item)"
                          :on-change="(file,fileLIst)=>handleChangeHt(file,fileLIst,item)"
                          :on-preview="handlePreview"
                          :auto-upload="false">
                          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2">
                      <el-button type="danger" size="mini" style="float: right;" :disabled="form.orgInsurances.length==1" @click="deleteRow(i)">删除</el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="saveForm('form')" size="medium">确 定</el-button>
              <el-button @click="dialogEditFormVisible = false" size="medium">取 消</el-button>
            </div>
          </el-dialog>
        </div>
      </template>
    </split-pane>



    <el-dialog title="设置管理员" top="10vh" :close-on-click-modal="false" :visible.sync="dialogAdminVisible">
      <el-form :model="adminUser">
        <el-form-item label="选择人员:" :label-width="formLabelWidth" prop="userName">
          <OrgUserSelect
            placeholder="请选择管理员"
            :orgId="selectOrgId"
            :value="adminUser.userName"
            @getAdmin="getAdmin($event)"
            style="width: 100%;"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="settingAdmin" size="medium">确 定</el-button>
        <el-button @click="dialogAdminVisible = false" size="medium">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="移动组织"
      top="10vh"
      :close-on-click-modal="false"
      :visible.sync="dialogChangeOrgVisible"
    >
      <el-form :model="org">
        <el-form-item label="选择组织" :label-width="formLabelWidth">
          <SelectTree
            :props="defaultProps"
            :options="orgTreeData"
            :value="org.id"
            :clearable="true"
            :accordion="true"
            placeholder="请选择组织"
            style="width: 80%;"
            @getValue="getValue($event)"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeOrg" size="medium">确 定</el-button>
        <el-button @click="dialogChangeOrgVisible = false" size="medium">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog class="roleDlg" title="企业绑定" width="90%" :close-on-click-modal="false" :visible.sync="dialogPersonVisible">
      <div style="width: 25%; height: 480px;">
        <OrgTree2 :parentMsg="parentMsg" v-on:treeInfo2="getTreeInfo2"></OrgTree2>
      </div>
      <div style="width: 70%;position: relative;">
        <el-transfer
          v-loading="roleDia_loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          style="width: 100%; text-align: left; "
          filterable
          :filter-method="filterMethod"
          filter-placeholder="请输入名称"
          v-model="selectedPersonData"
          :props="{key: 'id'}"
          :data="selectPersonData"
          :titles="['待选企业', '已选企业']"
          @change="choosePerson">
          <div @click="loadMore" slot="left-footer" style="width: 100%;height: 30px;cursor: pointer;display: flex;align-items: center;justify-content: center;background: #ddd;">
            加载更多
          </div>
        </el-transfer>
        <div style="height: 62px;padding: 0 15px;position: absolute;top: 40px;left: 0;display: flex;justify-content: center;flex-flow: column;">
          <el-input clearable size="small" placeholder="请输入名称" v-model="filterText" class="input-with-select">
            <el-button slot="append" @click="queryWait" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogPersonVisible = false">确 定</el-button>
        <el-button @click="dialogPersonVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  economicIndustryClassData,//经济行业分类
  managementClassCodeData,//管理分类
} from "../assets/data/data.js";
  import OrgTree from '@/components/OrgTree'
import OrgTree2 from '@/components/OrgTree2'
  import OrgUserSelect from '@/components/OrgUserSelect'
  import SelectTree from "@/components/FDTreeSelect";
  import md5 from '../js/md5';
  import {reqFunc} from "@/api";
  import {addAdmOrg, addOrUpdateAdmOrg, deleteAdmOrg, getAdmOrgList, getAdmOrgTree, setAdmin} from '../api/admOrg'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  export default {
    components: {
      OrgTree: OrgTree,
      OrgTree2:OrgTree2,
      OrgUserSelect: OrgUserSelect,
      SelectTree,
      Treeselect
    },
    data () {
      var checkNum = (rule, value, callback) => {
        if (!value) {
          return callback();
        }
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('请输入数字'));
          } else {
            if ((""+value).length > 20) {
              callback(new Error('数字长度不能超过20！'));
            } else {
              callback();
            }
          }
        }, 1000);
      };
      return {
        loginInfo:JSON.parse(sessionStorage.getItem("Admin-Data")||'{}'),
        filterText:'',
        sItem:{},
        selectPersonData: [],
        selectedPersonData: [],
        roleDia_loading: false,
        dialogPersonVisible: false,
        normalizer(node) {
          if (!node.children) {
            delete node.children;
          }
          return {
            id: node.id,
            label: node.label,
            children: node.children,
          }
        },
        bxData:[],//保险公司数据
        bxTreeData:[],
        economicIndustryClassData:economicIndustryClassData,//经济行业分类
        managementClassCodeData:[],//managementClassCodeData,//管理分类
        filterForm:{
          name:'',//组织名称
          // instituCreditCode:''//信用代码
        },
        pid:this.$route.query.pid||'',
        curOrgType:'',//选中的行政组织类型
        insuranceTypeData:[{
          label:'工伤保险',
          value:'1'
        },{
          label:'建工团体意外险',
          value:'2'
        },{
          label:'雇主责任险',
          value:'3'
        },{
          label:'安全生产责任险',
          value:'4'
        },{
          label:'建筑工程一切险',
          value:'5'
        },{
          label:'农民工工资支付履约保障保险',
          value:'6'
        },{
          label:'其他险种',
          value:'7'
        }],
        areaData:[],
        orgTreeData: [],
        defaultProps: {
          value: "id",
          children: "children",
          isLeaf: "leaf",
          checked: "false",
          label: "label"
        },
        org: {
          id: ""
        },
        dialogChangeOrgVisible:false,
        multipleSelection: [],
        parentId: '-1',
        newFormFlag: true,
        selectOrgId:'',
        parentMsg: {
          enumTitle: '组织管理',
          refreshTreeFlag: false
        },
        treeInfo: Object,
        dialogAddFormVisible: false,
        dialogEditFormVisible: false,
        dialogAdminVisible: false,
        formLabelWidth: '110px',
        formLabelWidth2: '155px',
        imageUrl1: '',
        imageUrl2: '',
        imageUrl3: '',
        totle: 0,
        rows: 10,
        currentPage: 1,
        pageWait:1,
        rowsWait:15,
        totalWait:0,
        tableData: [],
        aoType: [],
        personData:[],
        form: {
          insuredNum:0,
          economicIndustryClass:'',
          managementClassCode:'',
          businessScope:'',
          safetyPerson:'',
          safetyPersonPhone:'',
          issueGeneralCompanyId:'',//保险机构编码
          // xxxxxx:null,//所属保险公司
          orgInsurances:[{
            insuranceType:'1',
            purchased:1,
            startDate:'',//保险起期
            endDate:'',//保险止期
            fileListHt:[]
          }],
          cityCode:null,//城市编码
          cityName:'',//城市名称
          name:'',
          createDate: '',
          registerCapital: '',
          orgType:'',
          organizationCode:'',
          businessRegistNo:'',
          instituRegistNo:'',
          nationalTaxIdentNo:'',
          registAddress:'',
          businessAddress:'',
          orderNo:'',
          businessLicense:'',
          socialGroupRegistNo:'',
          privNoEntUnitRegNo:'',
          instituCreditCode:'',
          localTaxIdentNo:'',
          officeAddress:'',
          commPhone:'',
          commPerson:''
        },
        adminUser: {
          userId:'',
          userName:''
        },
        rules: {
          name: [
            { required: true, message: '请输入组织名称', trigger: 'blur' },
            { min: 1, max: 30, message: '长度在 1 到 30 个字符之间', trigger: 'blur' }
          ],
          registerCapital: [
            { validator: checkNum, trigger: 'blur' }
          ],
          organizationCode: [
            { validator: checkNum, trigger: 'blur' }
          ],
          businessLicense: [
            { validator: checkNum, trigger: 'blur' }
          ],
          businessRegistNo: [
            { validator: checkNum, trigger: 'blur' }
          ],
          socialGroupRegistNo: [
            { validator: checkNum, trigger: 'blur' }
          ],
          foundRegistNo: [
            { validator: checkNum, trigger: 'blur' }
          ],
          nationalTaxIdentNo: [
            { validator: checkNum, trigger: 'blur' }
          ],
          localTaxIdentNo: [
            { validator: checkNum, trigger: 'blur' }
          ],
          instituCreditCode: [
            { required: true, message: '请输入组织信用代码', trigger: 'blur' },
          ],
          commPhone: [
            { validator: checkNum, trigger: 'blur' }
          ],
          orderNo: [
            { validator: checkNum, trigger: 'blur' }
          ],
          instituRegistNo: [
            { validator: checkNum, trigger: 'blur' }
          ],
          privNoEntUnitRegNo: [
            { validator: checkNum, trigger: 'blur' }
          ],
          issueGeneralCompanyId:[{ required: false, message: '请输入保险机构编码', trigger: 'blur' }],
          // xxxxxx:[{ required: false, message: '请选择所属保险公司', trigger: 'blur' }]
        },
        url:''
      }
    },
    watch: {
      treeInfo: function (newVal, oldVal) {
        this.currentPage = 1
        this.parentId = newVal.listenParentId//this.$route.query.pid?this.$route.query.pid:newVal.listenParentId
        if(this.$route.query.pid){
          this.getTableData(oldVal?newVal.listenParentId:this.$route.query.pid)
        }else{
          this.getTableData(oldVal?newVal.listenParentId:this.$route.query.pid)
        }
      }
    },
    computed: {
    },
    methods: {
      getMngType(){
        let params = {"entityName":"std_industry_code","or":[],"orderBy":[{"desc":false,"fn":"ORDER_NO"}]}
        this.$axios.post(
          `/api/dftdstore/api/de/base/dynTree?&parentIdKey=SUPER_ID`,
          params
        ).then(data => {
          if (data.data.succeed) {
            this.managementClassCodeData = data.data.data
          } else {
            this.$message({
              message: data.data.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      },
      getSelectData:function () {
        this.$axios.get(`/api/admOrg/getOrgLinkOrgByOrgId?orgId=${this.selectRolesId}`).then(
          res => {
            if(res.data.success){
              this.selectedPersonData = res.data.data.map(it=>it.linkedOrgId)
            }
          })
          .catch(error => {
            console.log('error:' + error.toString())
          })
      },
      disPerson: function (index, row) {
        this.selectRolesId = row.orgId
        this.getSelectData()
        this.orgTreeMsg = {
          enumTitle: '组织管理',
          refreshTreeFlag: false
        }
        this.selectPersonData = []
        this.selectedPersonData = []
        this.getTreeInfo2(this.sItem)
        this.dialogPersonVisible = true
        // this.getOrgTreeInfo({ 'listenParentId': '-1'})
      },
      choosePerson: function(value, direction, movedKeys){
        this.$axios.post(
          `/api/admOrg/saveOrgLinkOrgByOrg`,
          this.$qs.stringify({
            orgId: this.selectRolesId,
            linkedOrgId: value.join(',')
          })
        ).then(data => {
          if (data.data.succeed) {
          } else {
            this.$message({
              message: data.data.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      },
      filterMethod(query, item) {
        console.log(query,item);
        if(item.name||item.label){
          return item.name?item.name.indexOf(query) > -1:item.label.indexOf(query) > -1;
        }else{
          return false;
        }
      },
      queryWait(){
        this.getTreeInfo2(this.sItem)
      },
      getSn(s){
        let sn = (s.$index + 1)+(this.currentPage-1)*this.rows
        return sn
      },
      getBxData:function () {
        this.$axios.get(`/api/admOrg/getAdmOrgTree4Form?wapper=1&async=0&id=1045876734075539456`).then(
          res => {
            if(res.data.success){
              this.bxData = res.data.data
            }
          })
          .catch(error => {
            console.log('error:' + error.toString())
          })
      },
      getBxTreeData:function () {
        let params = {
          async:0,
          orgId:'1045876734075539456'
        }
        this.$axios.post(`/api/admOrg/getAdmOrgTree`,this.$qs.stringify(params)).then(
          res => {
            if(res.status == 200){
              this.bxTreeData = res.data
            }
          })
          .catch(error => {
            console.log('error:' + error.toString())
          })
      },
      findNodeWithParent(data, targetCode) {
        for (const parentNode of data) {
          if (parentNode.children) {
            for (const childNode of parentNode.children) {
              if (childNode.code === targetCode) {
                return {
                  parent: parentNode,
                  node: childNode
                };
              }
            }
          }
        }
        return null;
      },
      queryData(){
        this.getTableData(this.$route.query.pid?this.$route.query.pid:this.treeInfo.listenParentId)
      },
      querySet(){
        this.filterForm = {
          name:'',
          instituCreditCode:''
        }
        this.getTableData(this.$route.query.pid?this.$route.query.pid:this.treeInfo.listenParentId)
      },
      changeOrgType(val){
        this.curOrgType = this.aoType.find(it=>it.id==val)
        if(this.curOrgType.code == 'bx'){
          this.rules.issueGeneralCompanyId[0].required = true
          // this.rules.xxxxxx[0].required = false
        }else if(this.curOrgType.code == 'qy'){
          // this.rules.xxxxxx[0].required = true
          this.rules.issueGeneralCompanyId[0].required = false
        }else{
          this.rules.issueGeneralCompanyId[0].required = false
          // this.rules.xxxxxx[0].required = false
        }
      },
      handlePhoneInput(value,row,key) {//手机号座机号验证
        // 手机号处理（限制11位）
        if (/^1\d*$/.test(value)) {
          row[key] = value.replace(/\D/g, '').slice(0, 11)
        }
        // 座机号处理（限制13字符，单减号）
        else {
          row[key] = value.replace(/[^\d-]/g, '')
            .replace(/-{2,}/g, '-')
            .slice(0, 13)
        }
      },
      handlePreview(file) {
        if(file.url){
          window.open(file.url);
        }else if(file.raw.type == 'application/pdf'){
          const blob = new Blob([file.raw], {type: 'application/pdf'});
          console.log('Blob信息:', blob.size, blob.type); // 检查大小和类型
          window.open(URL.createObjectURL(blob))
        }
      },
      handleRemoveHt(file, fileList,item) {
        item.fileListHt = fileList
        item.fileHt = ''
      },
      handleChangeHt(file, fileList,item) {
        item.fileHt = file
        item.fileListHt = [file]
      },
      deleteRow(index) {
        if(this.form.orgInsurances.length>1){
          this.form.orgInsurances.splice(index, 1)
        }
      },
      addItem(){
        if(this.form.orgInsurances.length<7){
          this.form.orgInsurances.push({
            insuranceType:'1',
            purchased:1,
            fileListHt:[]
          })
        }
      },
      removeEmptyChildren(obj) {
        if (Array.isArray(obj)) {
          return obj.map(item => this.removeEmptyChildren(item));
        } else if (typeof obj === 'object' && obj !== null) {
          const newObj = {};
          for (const key in obj) {
            if (key === 'children' && Array.isArray(obj[key]) && obj[key].length === 0) {
              continue; // 跳过空children
            }
            newObj[key] = this.removeEmptyChildren(obj[key]);
          }
          return newObj;
        }
        return obj;
      },
      getAreaData(){
        let url = '/dftdstore/api/de/base/dynTree'
        let method = 'post'
        let params = {
          parentIdKey:'SUPER_ID'
        }
        let data = {
          "entityName":"std_division",
          "or":[],
          "orderBy":[{"desc":false,"fn":"ORDER_NO"}]
        }
        reqFunc(url, method,data,params).then(res => {
          if (res.success) {
            this.areaData = res.data
            this.areaData = this.removeEmptyChildren(this.areaData)
          }
        })
      },
      getLabelByPath(data, selected) {
        let result = [];
        let current = data;

        for (let i = 0; i < selected.length; i++) {
          const val = selected[i];
          const item = current.find(node => node.CODE == val);

          if (!item) break;
          result.push(item.NAME);
          current = item.children || [];
        }

        return result.join('/');
      },
      handleChangeAddress(value) {
        const nodes = this.$refs.cascaderRef.getCheckedNodes();
        if (nodes.length > 0) {
          this.form.cityName = nodes[0].pathLabels.join('/'); // 直接获取中文路径
        } else {
          this.form.cityName = this.getLabelByPath(this.areaData, value)
        }
        console.log('所在城市:', this.form.cityName);
      },
      handleChangeAddressJj(value) {
        const nodes = this.$refs.cascaderRefJj.getCheckedNodes();
        if (nodes.length > 0) {
          this.form.economicIndustryClassText = nodes[0].pathLabels.join('/'); // 直接获取中文路径
        } else {
          this.form.economicIndustryClassText = this.getLabelByPath(this.economicIndustryClassData, value)
        }
        console.log('经济行业分类:', this.form.economicIndustryClassText);
      },
      handleChangeAddressGl(value) {
        const nodes = this.$refs.cascaderRefGl.getCheckedNodes();
        if (nodes.length > 0) {
          this.form.managementClassText = nodes[0].pathLabels.join('/'); // 直接获取中文路径
        } else {
          this.form.managementClassText = this.getLabelByPath(this.managementClassCodeData, value)
        }
        console.log('管理分类:', this.form.managementClassText);
      },
      changeOrg() {
        if (this.org.id === null || this.org.id === "") {
          this.$message({
            type: "warning",
            message: "请先选择组织!"
          });
          return;
        }

        var orgIds = [];
        for (var index in this.multipleSelection) {
          orgIds.push(this.multipleSelection[index].orgId);
        }

        var params = {
          parentId: this.org.id,
          orgId: orgIds.join(',')//JSON.stringify(orgIds)
        }

        this.$axios.post(
          "/api/admOrg/moveOrg",
          this.$qs.stringify(params)
        ).then(response => {
          if (response.data.succeed) {
            this.getTableData(this.$route.query.pid?this.$route.query.pid:this.treeInfo.listenParentId);
            this.parentMsg = {
              enumTitle: '组织管理',
              refreshTreeFlag: true
            }
            this.dialogChangeOrgVisible = false;
            this.$message({
              type: "success",
              message: "移动组织成功!"
            });
          } else {
            this.$message({
              message: response.data.msg?response.data.msg:'变更失败',
              showClose: true,
              type: "error"
            });
          }
        }).catch(e=>{
          console.log('变更异常',e)
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getOrgTree() {
        getAdmOrgTree(this.$qs.stringify({ async: 0 }))
          .then(response => {
            if (response.length > 0) {
              this.orgTreeData = response;
              this.setDisabledNode(this.orgTreeData,this.multipleSelection)
            }
          })
          .catch(error => {
            console.log("error:" + error.toString());
          });
      },
      //@输入参数 id： 要查找数据对应的id
      // @输入参数 list： 要查询的树形结构数组
      // @输出：返回该数据或null
      findItemById(id, list) {
        let res = list.find(item => item.id == id)
        if (res) {
          return res
        } else {
          for (let i = 0; i < list.length; i++) {
            if (list[i].children instanceof Array && list[i].children.length > 0) {
              res = this.findItemById(id, list[i].children)
              if(res){
                return res
              }
            }
          }
          return null
        }
      },
      setDisabledNode(data,disNode){
        var temp = null
        data.forEach(it=>{
          temp = disNode.find(ix=>it.id == ix.orgId)
          if(temp){
            var parentNode = this.findItemById(temp.parentId,this.orgTreeData)
            parentNode.children = parentNode.children.filter(item=>item.id!=temp.orgId)
          }else{
            if(it.children&&it.children.length>0){
              this.setDisabledNode(it.children,disNode)
            }
          }
        })
      },
      getValue(value) {
        this.org.id = value;
      },
      showChangeOrg() {
        this.getOrgTree()
        if (this.multipleSelection.length == 0) {
          this.$message({
            type: "warning",
            message: "请先选择相应组织!"
          });
          return;
        }
        this.org.id = "";
        this.dialogChangeOrgVisible = true;
      },// 反选
      getAdmin(admin) {
        this.adminUser = admin
      },
      handleSizeChange (val) {
        this.rows = val
        this.currentPage = 1
        if(this.$route.query.pid){
          this.getTableData(this.$route.query.pid)
        }else{
          this.getTableData(this.$route.query.pid?this.$route.query.pid:this.treeInfo.listenParentId)
        }
      },
      handleCurrentChange (val) {
        this.currentPage = val
        if(this.$route.query.pid){
          this.getTableData(this.$route.query.pid)
        }else{
          this.getTableData(this.$route.query.pid?this.$route.query.pid:this.treeInfo.listenParentId)
        }
      },
      getTreeInfo2(val){
        this.selectPersonData = []
        this.sItem = val
        this.loadWaitData(val)
      },
      loadMore(){
        if(this.selectPersonData.length>=this.totalWait){
          return
        }
        this.pageWait++;
        this.loadWaitData(this.sItem)
      },
      loadWaitData(val){
        let data = {
          async:1,
          orgId:val.listenParentId,
          page:this.pageWait,
          rows:this.rowsWait
        }

        if(this.filterText){
          data.name = this.filterText
        }
        getAdmOrgTree(this.$qs.stringify(data)).then(response => {
          this.selectPersonData.push(...response.rows)
          this.totalWait = response.total
        }).catch(error => {
          console.log('error666:' + error.toString())
        })
      },
      getTreeInfo: function (data) {
        this.treeInfo = data
        if(data.listenParentId == '1045876734075539456'||data.type == 'bx'){//保险
          this.curOrgType = this.aoType.find(it=>it.code == 'bx')
          this.form.orgType = this.curOrgType.id
          this.rules.issueGeneralCompanyId[0].required = true
          // this.rules.xxxxxx[0].required = false
        }else if(data.listenParentId == '1045876675263762432'||data.type == 'qy'){//企业
          this.curOrgType = this.aoType.find(it=>it.code == 'qy')
          this.form.orgType = this.curOrgType.id
          // this.rules.xxxxxx[0].required = true
          this.rules.issueGeneralCompanyId[0].required = false
        }else if(data.listenParentId == '1045876813195284480'||data.type == 'jj'){//服务机构
          this.curOrgType = this.aoType.find(it=>it.code == 'jj')
          this.form.orgType = this.curOrgType.id
          this.rules.issueGeneralCompanyId[0].required = false
          // this.rules.xxxxxx[0].required = false
        }else{
          this.rules.issueGeneralCompanyId[0].required = false
          // this.rules.xxxxxx[0].required = false
        }
      },
      getTableData: function (parentId) {
        console.log('parentId=>',this.treeInfo)
        var params = {
          parentId: parentId === '-1' ? '' : parentId,
          page: this.currentPage,
          rows: this.rows
        }
        let isIc = !!this.$funcUtil.roleCheck().find(it=>it.type == 'ic')//是否保险机构账号
        if(isIc){//是保险账号
          if(this.treeInfo.listenParentId == '1045876734075539456'){//点击保险公司管理时查询登录账号的数据
            params.name = this.loginInfo.orgName
            params.parentId = this.loginInfo.orgs[0].parentId
          }
          if(this.treeInfo.listenParentId == '1045876675263762432') {//点击企业时，查询当前保险保险所属企业
            params.linkOrgId = this.loginInfo.orgId
          }
        }

        if(this.filterForm.name){
          params.name = this.filterForm.name
        }
        // if(this.filterForm.instituCreditCode){
        //   params.instituCreditCode = this.filterForm.instituCreditCode
        // }
        getAdmOrgList(this.$qs.stringify(params)).then(
          response => {
            let isIc = !!this.$funcUtil.roleCheck().find(it=>it.type == 'ic')//是否保险机构账号
            if(isIc){
              response.rows = response.rows.filter(it=>it.orgId != '1045876813195284480')//保险机构过虑掉服务机构
            }
            this.totle = response.total
            if (response.rows != null && response.rows.length > 0) {
              response.rows.some((val)=>{
                val.registerCapital=val.registerCapital?Number(val.registerCapital):'';
                val.organizationCode=val.organizationCode?Number(val.organizationCode):'';
                val.businessLicense=val.businessLicense?Number(val.businessLicense):'';
                val.businessRegistNo=val.businessRegistNo?Number(val.businessRegistNo):'';
                val.socialGroupRegistNo=val.socialGroupRegistNo?Number(val.socialGroupRegistNo):'';
                val.foundRegistNo=val.foundRegistNo?Number(val.foundRegistNo):'';
                val.nationalTaxIdentNo=val.nationalTaxIdentNo?Number(val.nationalTaxIdentNo):'';
                val.localTaxIdentNo=val.localTaxIdentNo?Number(val.localTaxIdentNo):'';
                // val.instituCreditCode=val.instituCreditCode?Number(val.instituCreditCode):'';
                // val.commPhone=val.commPhone?Number(val.commPhone):'';
                val.orderNo=val.orderNo?Number(val.orderNo):'';
                val.instituRegistNo=val.instituRegistNo?Number(val.instituRegistNo):'';
                val.privNoEntUnitRegNo=val.privNoEntUnitRegNo?Number(val.privNoEntUnitRegNo):'';
                val.code = md5(val.code).substr(9,16);
              })
              this.tableData = response.rows;
            } else {
              this.tableData = []
            }
          })
          .catch(error => {
            console.log('error:' + error.toString())
          })
      },
      getAdministrativeOrganizationType:function () {
        this.$axios.get('/api/category/getCategoryList/key?value=adminOrg').then(
          response => {
            if (response.data.succeed) {
              this.aoType = response.data.data
              if(this.$route.query.pid == '1045876734075539456'){//保险
                this.curOrgType = this.aoType.find(it=>it.code == 'bx')
                this.form.orgType = this.curOrgType.id
              }else if(this.$route.query.pid == '1045876675263762432'){//企业
                this.curOrgType = this.aoType.find(it=>it.code == 'qy')
                this.form.orgType = this.curOrgType.id
              }else if(this.$route.query.pid == '1045876813195284480'){//服务机构
                this.curOrgType = this.aoType.find(it=>it.code == 'jj')
                this.form.orgType = this.curOrgType.id
              }
            } else {
              console.log('error:' + response.data.msg)
            }
          })
          .catch(error => {
            console.log('error:' + error.toString())
          })
      },
      getPerson:function (id) {
        var params = {
          orgId: id,
          page:1,
          rows:999
        }
        this.$axios.post('/api/baseUser/getUserList',this.$qs.stringify(params)).then(
          response => {
            this.personData = response.data.rows
          })
          .catch(error => {
            console.log('error:' + error.toString())
          })
      },
      addForm:function() {
        let orgType = this.form.orgType
        this.form = {parentId:this.parentId === '-1' ? '' : this.parentId,orgInsurances:[{
            insuranceType:'1',
            purchased:1,
            startDate:'',//保险起期
            endDate:'',//保险止期
            fileListHt:[]
          }],
          cityCode:'',//城市编码
          cityName:'',//城市名称
          }
          this.form.orgType = orgType
        this.sealType = '公章类型1'
        this.newFormFlag = true
        this.dialogAddFormVisible = true
      },
      editForm:async function (form) {
        let res = await reqFunc(`/admOrg/getAdmOrg/${form.orgId}?_=${new Date().getTime()}`, 'get')
        if(res.success){
          form = res.data
        }
        if(form.hasOwnProperty('createTime')){
          delete form.createTime
        }
        // form.orgInsurances.forEach(it=>{
        //   if(it.fileId){
        //     if(!it.fileListHt){
        //       it.fileListHt = []
        //     }
        //     it.fileListHt.push({name:it.fileId.split('#-#')[0],url:`/api/fs/files/download/${it.fileId.split('#-#')[1]}`,fid:it.fileId.split('#-#')[1]})
        //   }
        // })

        this.getPerson(form.orgId)
        if(form.cityCode){
          try {
            form.cityCode = form.cityCode.replace('[','').replace(']','')
            if(form.cityCode.indexOf(',')!=-1){
              form.cityCode = form.cityCode.split(',')
              form.cityCode.map(it=>{return it.toString()})
            }
          }catch (e) {
            console.log('转换错误')
          }
        }
        if(form.economicIndustryClass){
          try {
            form.economicIndustryClass = form.economicIndustryClass.replace('[','').replace(']','')
            if(form.economicIndustryClass.indexOf(',')!=-1){
              form.economicIndustryClass = form.economicIndustryClass.split(',')
              form.economicIndustryClass.map(it=>{return it.toString()})
            }
          }catch (e) {
            console.log('转换错误')
          }
        }
        if(form.managementClassCode){
          try {
            form.managementClassCode = form.managementClassCode.replace('[','').replace(']','')
            if(form.managementClassCode.indexOf(',')!=-1){
              form.managementClassCode = form.managementClassCode.split(',')
              form.managementClassCode.map(it=>{return it.toString()})
            }
          }catch (e) {
            console.log('转换错误')
          }
        }
        // if (form.cityCode && form.cityCode.indexOf(',') != -1) {
        //   form.cityCode = form.cityCode.split(',')
        // }
        this.form = Object.assign({}, form);

        if (!this.form.orgInsurances) {
          this.form.orgInsurances = [{
            insuranceType: '1',
            purchased: 1,
            startDate: '',//保险起期
            endDate: '',//保险止期
            fileListHt: []
          }]
        }
        this.curOrgType = this.aoType.find(it=>it.id == this.form.orgType)
        this.newFormFlag = false
        this.imageUrl1 = `/api/admOrg/getImg?orgId=${this.form.orgId}&imgType=1&tempid=${Math.random()}`
        this.imageUrl2 = `/api/admOrg/getImg?orgId=${this.form.orgId}&imgType=2&tempid=${Math.random()}`
        this.imageUrl3 = `/api/admOrg/getImg?orgId=${this.form.orgId}&imgType=3&tempid=${Math.random()}`

        //经济行业分类
        if(this.form.economicIndustryClass){
          if(this.form.economicIndustryClass.indexOf(',')!=-1){//正常操作选择录入的
            this.form.economicIndustryClass = this.form.economicIndustryClass.split(',')
          }else{
            let item = this.economicIndustryClassData.find(it=>it.code == this.form.economicIndustryClass)
            if(item){//在一级中找到直接赋值
              this.form.economicIndustryClass = [item.code]
            }else{//否则是子级，找父级再赋值
              let temp = this.findNodeWithParent(this.economicIndustryClassData,this.form.economicIndustryClass)
              if(temp) {
                this.form.economicIndustryClass = [temp.parent.code, temp.node.code]
              }
            }
          }
        }

        //管理分类
        if(this.form.managementClassCode){
          if(this.form.managementClassCode.indexOf(',')!=-1){//正常操作选择录入的
            this.form.managementClassCode = this.form.managementClassCode.split(',')
          }else{
            let item = this.managementClassCodeData.find(it=>it.CODE == this.form.managementClassCode)
            if(item){//在一级中找到直接赋值
              this.form.managementClassCode = [item.code]
            }else{//否则是子级，找父级再赋值
              let temp = this.findNodeWithParent(this.managementClassCodeData,this.form.managementClassCode)
              if(temp) {
                this.form.managementClassCode = [temp.parent.code, temp.node.code]
              }
            }
          }
        }

        this.dialogEditFormVisible = true
      },
      showSettingAdmin:function(form) {
        this.adminUser = {userId:form.userId, userName:form.userName}
        this.selectOrgId = form.orgId
        this.dialogAdminVisible = true
      },
      settingAdmin() {
        if (this.adminUser.userId === null || this.adminUser.userId === '') {
          this.$message({
            message: '请先选择管理员',
            type: 'warning'
          })
          return
        }

        setAdmin(this.$qs.stringify({userId:this.adminUser.userId, orgId:this.selectOrgId})).then(response => {
          if (response.succeed) {
            this.dialogAdminVisible = false
            this.getTableData(this.$route.query.pid?this.$route.query.pid:this.treeInfo.listenParentId)
            this.$message({
              type: 'success',
              message: '设置成功!'
            });
          } else {
            this.$message({
              message: response.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      },
      async uploadFiles(file) {
        let fId = ''
        let formData = new FormData();
        formData.append("file", file.raw)
        let url = '/zuul/fs/files/upload'
        let method = 'post'
        await reqFunc(url, method, formData).then(async res => {
          fId =  res.id
        })
        return fId
      },
      saveForm:function (form) {
        this.$refs[form].validate(async (valid) => {
          if (valid) {

            if(this.form.cityCode&&Array.isArray(this.form.cityCode)){
              this.form.cityCode = `[${this.form.cityCode.join(',')}]`
            }
            if(this.form.economicIndustryClass&&Array.isArray(this.form.economicIndustryClass)){
              this.form.economicIndustryClass = `[${this.form.economicIndustryClass.join(',')}]`//this.form.economicIndustryClass.join(',')
            }
            if(this.form.managementClassCode&&Array.isArray(this.form.managementClassCode)){
              this.form.managementClassCode = `[${this.form.managementClassCode.join(',')}]`//this.form.managementClassCode.join(',')
            }
            // if (this.form.orgInsurances && this.form.orgInsurances.length > 0) {
            //   for (const it of this.form.orgInsurances) {
            //     // 检验成功，先传文件，再保存数据
            //     it.fileId = it.fileHt ? it.fileHt.name + '#-#' + await this.uploadFiles(it.fileHt) : (it.fileId ? it.fileId : '')
            //     delete it.fileHt
            //     delete it.fileListHt
            //   }
            // }

            // let orgInsurances = JSON.parse(JSON.stringify(this.form.orgInsurances))
            // this.form.jsonOrgInsurance = JSON.stringify(this.form.orgInsurances)

            delete this.form.topOrg
            delete this.form.children

            let formdata = JSON.parse(JSON.stringify(this.form))
            delete formdata.orgInsurances
            addOrUpdateAdmOrg(this.newFormFlag, this.$qs.stringify(formdata)).then(async response => {
              if (response.succeed) {

                if (this.loginInfo.orgTypeCode == 'bx') {
                  let linkIds = []
                  let res = await this.$axios.get(`/api/admOrg/getOrgLinkOrgByOrgId?orgId=${this.loginInfo.orgId}`)
                  if(res.data.success){
                    linkIds = res.data.data.map(it=>it.linkedOrgId)
                  }
                  linkIds.push(response.data)
                  this.$axios.post(
                    `/api/admOrg/saveOrgLinkOrgByOrg`,
                    this.$qs.stringify({
                      orgId: this.loginInfo.orgId,
                      linkedOrgId: linkIds.join(',')
                    })
                  ).then(data => {
                    if (data.data.succeed) {
                    } else {
                      this.$message({
                        message: data.data.msg,
                        showClose: true,
                        type: 'error'
                      })
                    }
                  })
                }

                this.$message.success('保存成功')
                this.dialogAddFormVisible = false
                this.dialogEditFormVisible = false
                this.getTableData(this.treeInfo.listenParentId)
                // if(this.$route.query.pid){
                //   this.getTableData(this.$route.query.pid)
                // }else{
                //   this.getTableData(this.$route.query.pid?this.$route.query.pid:this.treeInfo.listenParentId)
                // }
                this.parentMsg = {
                  enumTitle: '组织管理',
                  refreshTreeFlag: true
                }
              } else {
                this.$message({
                  message: response.msg,
                  showClose: true,
                  type: 'error'
                })
              }
            })
          } else {
            return false
          }
        })
      },
      showDelAlert:function(data) {
        this.$confirm('此操作将永久删除该组织 '+data.name+', 是否继续?', '提示', {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delForm(data)
        })
      },
      delForm:function (data) {
        deleteAdmOrg(this.$qs.stringify({orgId:data.orgId})).then(response => {
          if (response.succeed) {
            this.getTableData(this.treeInfo.listenParentId)//this.$route.query.pid?this.$route.query.pid:this.treeInfo.listenParentId)
            this.parentMsg = {
              enumTitle: '组织管理',
              refreshTreeFlag: true
            }
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              message: response.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      },
      handleAvatarSuccess1(res, file) {
        this.imageUrl1 = URL.createObjectURL(file.raw);
      },
      handleAvatarSuccess2(res, file) {
        this.imageUrl2 = URL.createObjectURL(file.raw);
      },
      handleAvatarSuccess3(res, file) {
        this.imageUrl3 = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
       const isImage =
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/gif";;

        if (!isImage) {
          this.$message.error("上传图片只能是png、jpg、jpeg、gif格式!");
        }
        return isImage;
      }
    },
    mounted() {
      if(this.$route.query.pid == '1045876734075539456'){//保险，设置保险机构编码必填校验
        this.rules.issueGeneralCompanyId[0].required = true
        // this.rules.xxxxxx[0].required = false
      }else if(this.$route.query.pid == '1045876675263762432'){//企业，设置所属保险公司必填校验
        // this.rules.xxxxxx[0].required = true
        this.rules.issueGeneralCompanyId[0].required = false
      }else{
        this.rules.issueGeneralCompanyId[0].required = false
        // this.rules.xxxxxx[0].required = false
      }
      // this.getTableData()
      this.getAdministrativeOrganizationType()
      this.getAreaData()
      // this.getBxData()
      this.getBxTreeData()
      // let reScript = document.createElement("script");
      //   reScript.setAttribute(
      //       "src",
      //       "https://cdn.bootcss.com/blueimp-md5/2.10.0/js/md5.js"
      //   );
      // document.head.appendChild(reScript);
      this.getMngType()
    }
  }
</script>

<style scoped lang="less">
  #main{
    height: calc(100% - 40px);
    width: calc(100% - 40px);
    padding: 20px;
    background: #F0F2F5;
  }
  /deep/ .splitter-pane-resizer.vertical[data-v-212fa2a4]{
    background-color: #e6eef8;
    width:0px;
  }
  /deep/ .splitter-pane-resizer[data-v-212fa2a4]{
       opacity: initial;
  }
  #omTreeDivs{
    width: calc(100% - 40px);
    height: 95%;
    height: -webkit-calc(100% - 10px);
    height: calc(100% - 40px);
    float: left;
    background: white;
    padding: 20px;
    border-radius: 20px;
  }
  #listTables{
    width: calc(100% - 20px - 20px);
    float: right;
    background: white;
    padding: 10px;
    height: calc(100% - 20px);
    border-radius: 20px;
  }

  #rightName {
    float: left;
    color: black;
    font-size: 18px;
    font-weight: bold;
    margin-left: 15px;
    margin-top: 15px;
  }
  .rightTopButton {
    //text-align: right;
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 15px;
  }
  .rightContent {
    height: 92.5%;
    height: -webkit-calc(100% - 60px);
    height: calc(100% - 60px);
    background: white;
    overflow: auto;
    padding: 0 10px 32px;
    box-sizing: border-box;
  }
  .pagination {
    height: 32px;
    margin: 0px 0 -32px;
    padding: 20px 0 10px;
    //background: #ECF5FF;
    text-align: right;
  }
  .table {
    height: calc(100% - 30px);
    background: #D9C666;
  }
  .image-slot{
    display:flex;
    justify-content:center;
    align-items:center;
    width:100%;
    height:100%;
    background:#f5f7fa;
    color:#909399;
    font-size:14px
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }

  /deep/.el-button--primary{
    background-color:#4873C0 !important;
    border-color:#4873C0 !important;
    color: white !important;
  }

  /deep/.splitter-pane-resizer{
    display: none !important;
  }

  /deep/.el-pager li.active{
    background: #4873c0!important;
    color: white !important;
  }

  /deep/.el-table thead{
    height: 45px !important;
  }

  /deep/.el-table .el-table__cell{
    border-color:#C4E2F8;
    height: 50px;
  }
  /deep/.el-table--border{
    border:1px solid #C4E2F8;
  }
  /deep/.el-table td.el-table__cell, /deep/.el-table th.el-table__cell.is-leaf{
    border-color:#C4E2F8;
  }
  /deep/.el-radio__label{
    padding-left: 1px;
  }
  /depp/.el-upload-list__item-name{
    margin-right: 0px;
  }
  /deep/.el-radio{
    margin-right: 10px;
  }
  /deep/.vue-treeselect__placeholder, /deep/.vue-treeselect__single-value{
    line-height: inherit;
  }
  /deep/.vue-treeselect--has-value .vue-treeselect__input{
    height: 40px;
  }
</style>
<style lang="less" scope>
.roleDlg .el-dialog__body{
  padding: 0 10px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  .el-transfer{
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    .el-transfer__buttons{
      display: flex;
      flex-flow: column;
      //width: 100%;
      justify-content: center;
      align-items: center;
      padding: 0;
      flex: auto;
      .el-button+.el-button{
        margin: 0;
      }
    }
    .el-transfer-panel{
      width: 40%;
      min-width: 280px;
      min-height: 480px;

      .is-with-footer{
        padding-top: 62px;
        padding-bottom: 0;
        .el-transfer-panel__filter{
          display: none !important;
        }
      }

      .el-transfer-panel__body{
        height: 380px;
        .el-transfer-panel__list{
          height: calc(100% - 30px) !important;
          .el-transfer-panel__item{
            min-width: 240px;
            margin-right: auto;
          }
        }
      }
      .el-transfer-panel__footer{
        height: 30px;
      }
    }
  }
}
.input-with-select{

  .el-input__inner{
    border-radius: 16px 0 0 16px;
  }
  .el-input-group__append{
    border-radius: 0 16px 16px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/OrganizationManage.vue